module.exports = __webpack_public_path__ + "img/type2_bg.df9022f2.png";